<template>
    <div>
        <!--==============================================================================-->
        <v-dialog v-model="SmallDialog" content-class="bottom-right-dialog" width="300">
            <v-sheet color="white" height="100%" width="100%" class="dialog-sheet pa-4">
                <div class="popup-head">
                    <div class="popup-icon">
                        <v-icon size="38" color="white">mdi-lightbulb-on-outline</v-icon>
                    </div>
                    <div>
                        <v-chip small outlined color="primary" class="mb-3"><h3 v-text="category"></h3></v-chip>
                        <h4 v-text="title"></h4>
                    </div>
                    <v-btn icon x-small class="popup-x" @click="popupClose()">
                        <v-icon size="24">mdi-close</v-icon>
                    </v-btn>
                </div>
                <div class="my-5">
                    <h5 v-html="body"></h5>
                </div>
                <div class="mt-5">
                    <v-btn block color="primary" @click="fullInfo()"><h4>詳しく読む</h4></v-btn>
                    <v-btn block text color="primary" @click="popupClose()"><h4>閉じる</h4></v-btn>
                </div>
            </v-sheet>
        </v-dialog>
        <!--==============================================================================-->
        <v-dialog v-model="LargeDialog" fullscreen>
            <v-card class="d-flex flex-column fill-height">
                <v-toolbar dark color="primary" class="flex-grow-0" height="35">
                    <v-toolbar-title>お知らせ</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="
                            $emit('close');
                            LargeDialog = false;
                        "
                        small
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="umilog-iframe-wrap">
                    <iframe :src="articleUrl" frameborder="0" class="umilog-iframe" scrolling="yes"></iframe>
                </div>
                <!--
                <v-card-text class="pa-0 flex-grow-1 d-flex">
                </v-card-text>
                -->
            </v-card>
        </v-dialog>
        <!--==============================================================================-->
    </div>
</template>

<style>
.bottom-right-dialog {
    position: fixed;
    right: 5px;
    bottom: 50px;
    margin: 0;
    align-self: flex-end;

    border: 2px solid #1976d2;
    border-radius: 16px 16px 16px 16px;
}
.dialog-sheet {
    height: 100%;
    overflow-y: auto;
}
.popup-x {
    position: absolute;
    top: 10px;
    right: 9px;
}
.popup-head {
    display: flex;
    align-items: center;
    gap: 13px;
    padding-right: 30px;
}
.popup-icon {
    width: 60px;
    height: 60px;
    flex: 0 0 auto;
    border-radius: 50%;
    background: radial-gradient(circle at 30% 25%, #168aff, #005fd2 72%);
    display: grid;
    place-items: center;
}
.umilog-iframe-wrap {
    flex: 1 1 auto;
    min-height: 0;
    height: 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
}
.umilog-iframe {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 0;
    border: 0;
}
</style>

<script>
// @ is an alias to /src
import CryptoJS from "crypto-js";
export default {
    name: "DevicesList",
    components: {},
    //========================================================
    data() {
        return {
            SmallDialog: false,
            LargeDialog: false,
            category: "",
            title: "",
            body: "",
            wpUrl: "https://umilog.ise-hp.com/wp-json/wp/v2/posts",
            articleUrl: "https://umilog.ise-hp.com/",
            saveMd5: "",
        };
    },
    //========================================================
    props: {
        openFullDlg: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        openFullDlg(newVal) {
            this.LargeDialog = newVal;
        },
    },
    //========================================================
    mounted: async function () {
        this.SmallDialog = false;
        this.LargeDialog = this.openFullDlg;
        //-------------------------------
        await this.getUmilogInfo();
        await new Promise((r) => setTimeout(r, 1500));
        if (this.title && !this.LargeDialog) {
            this.SmallDialog = true;
        }
    },
    //========================================================
    methods: {
        fullInfo() {
            this.SmallDialog = false;
            this.LargeDialog = true;
        },
        //===================================================
        async getUmilogInfo() {
            const oldMd5 = this.$localStorage.get("wp-hash");

            await this.axios({
                method: "GET",
                url: this.wpUrl,
                timeout: 30000,
            }).then((response) => {
                const resTxt = JSON.stringify(response.data);
                const newMd5 = CryptoJS.MD5(resTxt).toString();
                if (response.data[0] && oldMd5 !== newMd5) {
                    const WPData = response.data[0];
                    this.category = WPData.category_names[0];
                    this.title = WPData.title.rendered;
                    this.body = WPData.excerpt.rendered;
                    //this.$localStorage.set("wp-hash", newMd5);
                    this.saveMd5 = newMd5;
                }
            });
        },
        //====================================================
        popupClose() {
            this.SmallDialog = false;
            this.$localStorage.set("wp-hash", this.saveMd5);
        },
    },
    //========================================================
};
</script>
